import { render } from "./KnowledgeBaseModeFields.vue?vue&type=template&id=485a4003&scoped=true"
import script from "./KnowledgeBaseModeFields.vue?vue&type=script&lang=js"
export * from "./KnowledgeBaseModeFields.vue?vue&type=script&lang=js"

import "./KnowledgeBaseModeFields.vue?vue&type=style&index=0&id=485a4003&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485a4003"]])

export default __exports__